import { ComponentOptions, createApp, defineComponent } from "vue";

/**
 * Vue 3 has no `inline-template`. Themes that still ship DOM markup from Liquid
 * must compile that HTML as the component `template`.
 */
export function mountWithElTemplate(
  el: HTMLElement,
  options: ComponentOptions
) {
  const template = el.innerHTML;
  el.innerHTML = "";
  return createApp(
    defineComponent({
      ...options,
      template,
    } as ComponentOptions)
  ).mount(el);
}
